import React, { Component } from "react";
import { Nav, Tab } from "react-bootstrap";
import { BiHide, BiShow } from "react-icons/bi";
import { FiEye, FiMoreVertical, FiTrash } from "react-icons/fi";
import { HiPlus } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import Empty from "../../../base/features/blocks/Empty";
import ProductCard from "../../../base/features/blocks/ProductCard";
import Spinner from "../../../base/features/micro/Spinner";
import ManagementNavBottom from "../blocks/ManagementNavBottom";
import CustomProduct from "./blocks/CustomProduct";
import {
  activatShop,
  change_stock,
  deleteProduct,
  getGityShopCategoriesService,
  managementCustomProducts,
  managementShopProducts,
  showProduct,
} from "./services";
import { BsCartCheck, BsCartX } from "react-icons/bs";
import ShopCategoryItem from "../../shop/blocks/shopCategoryItem";

class ManagementProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultActiveKey: "usual",
      products: null,
      customProducts: null,
      hasMore: false,
      customHasMore: false,
      productMore: false,
      acceptModal: false,
      nextUrl: "",
      customNextUrl: "",
      searchKey: "",
      customSearchKey: "",
      type: "",
      selectedProduct: {},
      selectedProductIndex: "",
      shopUid: window.location.pathname.split("/")[2],
      selectedShop: null,
      pending: false,
      gityCategories: [],
      selectedCategory: "",
    };
  }
  componentDidMount() {
    this.getProducts();
    this.getGityShopCategories();
    if (!this.props.activation) {
      this.getCustomProducts();
    }
    this.setState({
      selectedShop:
        localStorage.getItem("selected_shop") &&
        JSON.parse(localStorage.getItem("selected_shop")),
    });
  }
  getProducts() {
    let q = this.state.searchKey;
    let shop_category = this.state.selectedCategory || "";
    managementShopProducts(this.state.shopUid, q, "", shop_category).then(
      (items) => {
        if (q === this.state.searchKey && items) {
          this.setState({
            products: items.results,
            hasMore: items.next ? true : false,
            nextUrl: items.next,
          });
        }
      }
    );
  }
  getCustomProducts() {
    let q = this.state.customSearchKey;
    managementCustomProducts(this.state.shopUid, q).then((items) => {
      if (q === this.state.customSearchKey && items) {
        this.setState({
          customProducts: items.results,
          customHasMore: items.next ? true : false,
          customNextUrl: items.next,
        });
      }
    });
  }
  fetchMoreData() {
    let shop_category = this.state.selectedCategory || "";
    managementShopProducts(
      this.state.shopUid,
      "",
      this.state.nextUrl,
      shop_category
    ).then((items) => {
      if (items) {
        var newProducts = this.state.products;
        newProducts = newProducts.concat(items.results);

        this.setState({
          products: newProducts,
          nextUrl: items.next,
          hasMore: items.next ? true : false,
        });
      }
    });
  }
  fetchMoreData2() {
    managementCustomProducts(
      this.state.shopUid,
      "",
      this.state.customNextUrl
    ).then((items) => {
      if (items) {
        var newProducts = this.state.customProducts;
        newProducts = newProducts.concat(items.results);

        this.setState({
          customProducts: newProducts,
          customNextUrl: items.next,
          customHasMore: items.next ? true : false,
        });
      }
    });
  }
  changeStock(p, product) {
    change_stock(this.state.shopUid, product.id, !product.has_stock).then(
      (items) => {
        if (items) {
          var new_products = this.state.products;
          new_products[p] = items;
          this.setState({ selectedProduct: items });
          this.setState({ products: new_products });
        }
      }
    );
  }
  show_product(show_on_menu) {
    this.setState({ acceptModal: false });
    showProduct(
      this.state.shopUid,
      this.state.selectedProduct.id,
      show_on_menu
    ).then((items) => {
      this.getProducts();
    });
  }
  delete_product() {
    this.setState({ acceptModal: false });
    deleteProduct(this.state.shopUid, this.state.selectedProduct.id).then(
      (items) => {
        this.getProducts();
      }
    );
  }
  activatShop() {
    this.setState({ pending: true });
    activatShop(this.state.shopUid).then((items) => {
      if (items) {
        localStorage.setItem(`selected_shop`, JSON.stringify(items));
        this.setShop(items);
      }
      this.setState({ pending: false });
    });
  }
  setShop(shop) {
    window.location.href = `/dashboard/${shop.uid}`;
  }
  getGityShopCategories() {
    getGityShopCategoriesService(this.state.shopUid).then((item) => {
      this.setState({ gityCategories: item?.shop_categories });
    });
  }
  render() {
    return (
      <div style={{ marginBottom: "120px" }}>
        <ManagementNavBottom />
        {this.props.activation && (
          <div
            className="row mx-0 px-0 position-fixed"
            style={{
              bottom: "20px",
              left: "20px",
              right: "20px",
              zIndex: "99",
            }}
          >
            <button
              disabled={
                this.state.pending ||
                !this.state.products ||
                this.state.products.length === 0
              }
              onClick={() => this.activatShop()}
              className="btn py-2-3 rounded28 bg-color-main text-white fw-bold bg-disabled"
            >
              {this.state.pending ? (
                <span className="spinner-border spinner-border-sm text-white align-middle"></span>
              ) : (
                "تایید و فعال سازی"
              )}
            </button>
          </div>
        )}
        {((this.props.activation &&
          this.state.products &&
          this.state.products.length !== 0) ||
          !this.props.activation) && (
          <div
            dir="ltr"
            className="position-fixed"
            style={{ bottom: "95px", left: "20px", zIndex: "9999" }}
          >
            <Link
              to={{
                pathname: `/dashboard/${this.state.shopUid}/p`,
                state: { isActivate: this.props.activation ? true : false },
              }}
            >
              <div
                className="rounded-circle row mx-0 nav-bottom-grad"
                style={{
                  height: "65px",
                  width: "65px",
                }}
              >
                <div className="col align-self-center text-center px-0">
                  <HiPlus size="38" className="text-white" />
                </div>
              </div>
            </Link>
          </div>
        )}
        <div className="col-12 px-4 py-2-3">
          <h1 className="fw-bold fs-4 mb-0">محصولات</h1>
        </div>
        <Tab.Container
          className="border-0 w-100"
          activeKey={this.state.defaultActiveKey}
          onSelect={(i) => this.setState({ defaultActiveKey: i })}
          defaultActiveKey={this.state.defaultActiveKey}
          id="tab-example2"
        >
          {!this.props.activation && (
            <div
              className="row mx-0 bg-white position-sticky shadow-sm"
              style={{ top: "0", zIndex: "9999999" }}
            >
              <div className="col-2 px-0" />

              <div className="col-4 text-center px-0">
                <Nav.Link
                  className={
                    "p-3 fw-bolder fs-6 " +
                    (this.state.defaultActiveKey === "usual"
                      ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                      : "text-muted")
                  }
                  eventKey="usual"
                >
                  عادی
                </Nav.Link>
              </div>

              {this.state.selectedShop &&
                this.state.selectedShop.config &&
                this.state.selectedShop.config.personalized_product && (
                  <div className="col-4 text-center px-0">
                    <Nav.Link
                      className={
                        "p-3 fw-bolder fs-6 " +
                        (this.state.defaultActiveKey === "custom"
                          ? "border-main border-3 color-main border-top-0 border-start-0 border-end-0"
                          : "text-muted")
                      }
                      eventKey="custom"
                    >
                      سفارشی
                    </Nav.Link>
                  </div>
                )}
              <div className="col-2 px-0" />
            </div>
          )}
          <div
            style={{
              overflow: "scroll hidden",
              whiteSpace: "nowrap",
              top: "59px",
              zIndex: "99999",
            }}
            className="px-0 py-3 col-12 scrollbar-hide position-sticky bg-white"
          >
            <Link
              to={{
                pathname: `/dashboard/${this.state.shopUid}/new-shop-category`,
              }}
            >
              <span
                className="color-main mx-2   rounded14 text-center"
                style={{
                  backgroundColor: "#2cc84d20",
                  padding: "3px 10px",
                }}
              >
                <HiPlus size="20" />
              </span>
            </Link>
            {this.state.gityCategories &&
              this.state.gityCategories.length > 0 && (
                <>
                  <ShopCategoryItem
                    key={"all"}
                    category={null}
                    text={"همه"}
                    selected={this.state.selectedCategory === ""}
                    onClick={(selected) => {
                      this.setState({ selectedCategory: "" }, () => {
                        if (selected) {
                          this.getProducts();
                        }
                      });
                    }}
                  ></ShopCategoryItem>

                  {this.state.gityCategories.map((item, index) => (
                    <ShopCategoryItem
                      key={index}
                      category={item}
                      text={item.name}
                      selected={this.state.selectedCategory === item.uid}
                      onClick={(selected) => {
                        this.setState({ selectedCategory: item.uid }, () => {
                          if (selected) {
                            this.getProducts();
                          }
                        });
                      }}
                    ></ShopCategoryItem>
                  ))}
                </>
              )}
          </div>

          <div className="row mx-0">
            <div className="col-12 px-0">
              <Tab.Content>
                <Tab.Pane eventKey="usual">
                  {this.state.products ? (
                    <section>
                      {!this.props.activation && (
                        <div
                          className="row mx-0 position-sticky bg-white"
                          style={{ top: "122px", zIndex: "99999" }}
                        >
                          <div className="col-12 px-4 pb-3 text-center">
                            <input
                              type="text"
                              value={this.state.searchKey}
                              onChange={(e) =>
                                this.setState(
                                  { searchKey: e.target.value },
                                  () => {
                                    this.getProducts();
                                  }
                                )
                              }
                              className="form-control px-3 py-2 rounded14 w-100"
                              style={{ height: "44px" }}
                              placeholder="جستجو کنید"
                            />
                            {this.state.searchKey.length !== 0 && (
                              <MdClose
                                size={26}
                                style={{ left: "37px", top: "0", bottom: "0" }}
                                className="position-absolute my-auto"
                                onClick={() =>
                                  this.setState({ searchKey: "" }, () => {
                                    this.getProducts();
                                  })
                                }
                              />
                            )}
                          </div>
                        </div>
                      )}
                      <InfiniteScroll
                        dataLength={this.state.products.length}
                        next={() => this.fetchMoreData()}
                        hasMore={this.state.hasMore}
                        className="row mx-0"
                        loader={<Spinner />}
                      >
                        {this.state.products.length === 0 && (
                          <section className=" text-center">
                            <Empty
                              type="product"
                              text={
                                this.props.activation
                                  ? "برای شروع فعالیت فروشگاه لازم است حداقل یک محصول یا کالا اضافه کنید."
                                  : "محصولی یافت نشد."
                              }
                            />
                            {this.props.activation && (
                              <Link
                                to={{
                                  pathname: `/dashboard/${this.state.shopUid}/p`,
                                  state: {
                                    isActivate: this.props.activation
                                      ? true
                                      : false,
                                  },
                                }}
                              >
                                <button className="btn rounded28 border py-2 px-4 small color-main">
                                  افزودن محصول
                                </button>
                              </Link>
                            )}
                          </section>
                        )}
                        {this.state.products.map((product, p) => (
                          <div key={p} className="col-12 px-0 border-bottom">
                            <ProductCard
                              product={product}
                              shopUid={this.state.shopUid}
                              payable_price={product.payable_price_str}
                              str={true}
                              isDashboard={true}
                            />
                            <div className="row mx-0 pb-4 px-4 justify-content-between">
                              <div className="col-auto px-0">
                                <Link
                                  to={`/dashboard/${this.state.shopUid}/p/${product.id}`}
                                >
                                  <button className="btn px-3 rounded28 border color-main fw-bold fs-6">
                                    ویرایش
                                  </button>
                                </Link>
                              </div>

                              <div className="col-auto px-0 align-self-center">
                                <div className="d-flex align-items-center">
                                  <div className="mx-2 text-muted">
                                    <span>{product?.visit_count}</span>
                                    <FiEye
                                      size="22"
                                      className="mx-1 text-muted"
                                    />
                                  </div>
                                  <FiMoreVertical
                                    size={20}
                                    onClick={() =>
                                      this.setState(
                                        {
                                          selectedProduct: product,
                                          selectedProductIndex: p,
                                        },
                                        () =>
                                          this.setState({ productMore: true })
                                      )
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="custom">
                  {this.state.customProducts ? (
                    <section>
                      <div
                        className="row mx-0 position-sticky bg-white"
                        style={{ top: "122px", zIndex: "99999" }}
                      >
                        <div className="col-12 px-4 pb-3 text-center">
                          <input
                            type="text"
                            value={this.state.customSearchKey}
                            onChange={(e) =>
                              this.setState(
                                { customSearchKey: e.target.value },
                                () => {
                                  this.getCustomProducts();
                                }
                              )
                            }
                            className="form-control px-3 py-2 rounded14 w-100"
                            style={{ height: "44px" }}
                            placeholder="جستجو کنید"
                          />
                          {this.state.customSearchKey.length !== 0 && (
                            <MdClose
                              size={26}
                              style={{ left: "37px", top: "0", bottom: "0" }}
                              className="position-absolute my-auto"
                              onClick={() =>
                                this.setState({ customSearchKey: "" }, () => {
                                  this.getCustomProducts();
                                })
                              }
                            />
                          )}
                        </div>
                      </div>
                      <InfiniteScroll
                        dataLength={this.state.customProducts.length}
                        next={() => this.fetchMoreData2()}
                        hasMore={this.state.customHasMore}
                        className="row mx-0 px-4"
                        loader={<Spinner />}
                      >
                        {this.state.customProducts.length === 0 ? (
                          <Empty type="product" text={"محصولی یافت نشد."} />
                        ) : (
                          this.state.customProducts.map((product, p) => (
                            <CustomProduct product={product} />
                          ))
                        )}
                      </InfiniteScroll>
                    </section>
                  ) : (
                    <Spinner />
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
        {this.state.productMore && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.productMore}
            toggle={() => this.setState({ productMore: false })}
          >
            <ModalBody className="row mx-0 px-4 py-5">
              <div
                className="col-12 px-1 mb-3 text-danger fw-bolder"
                onClick={() =>
                  this.setState({
                    type: "delete",
                    acceptModal: true,
                    productMore: false,
                  })
                }
              >
                <FiTrash size={28} />
                <span className="me-2 align-bottom">حذف محصول</span>
              </div>

              <div className="col-12 px-1 mb-4 text-muted fw-bold">
                {!this.state.selectedProduct.show_on_menu ? (
                  <section
                    onClick={() =>
                      this.setState({
                        type: "show",
                        acceptModal: true,
                        productMore: false,
                      })
                    }
                  >
                    <BiShow size={28} />
                    <span className="me-2 align-bottom">
                      نمایش در لیست محصولات
                    </span>
                  </section>
                ) : (
                  <section
                    onClick={() =>
                      this.setState({
                        type: "hide",
                        acceptModal: true,
                        productMore: false,
                      })
                    }
                  >
                    <BiHide size={28} />
                    <span className="me-2 align-bottom">
                      عدم نمایش در لیست محصولات
                    </span>
                  </section>
                )}
              </div>
              <div className="col-12 px-1 mb-4 text-muted fw-bold">
                <section
                  onClick={(e) =>
                    this.changeStock(
                      this.state.selectedProductIndex,
                      this.state.selectedProduct
                    )
                  }
                >
                  {this.state.selectedProduct?.has_stock ? (
                    <BsCartX size={28} />
                  ) : (
                    <BsCartCheck size={28} />
                  )}
                  <span className="me-2 align-bottom">
                    {this.state.selectedProduct?.has_stock
                      ? "غیر قابل سفارش"
                      : "قابل سفارش"}
                  </span>
                </section>
              </div>

              <div className="col-12 px-1">
                <button
                  className="btn py-2-3 w-100 rounded28 border text-muted fw-bolder"
                  onClick={() => this.setState({ productMore: false })}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
        {this.state.acceptModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.acceptModal}
            toggle={() => this.setState({ acceptModal: false })}
          >
            <ModalBody className="row mx-0 p-4">
              {this.state.type === "delete" ? (
                <div className="col-12 px-1 mb-3">
                  <p className="fw-bolder">حذف نظر</p>
                  <p className="text-muted">
                    آیا برای حذف نظر خود اطمینان دارید؟
                  </p>
                </div>
              ) : this.state.type === "hide" ? (
                <div className="col-12 px-1 mb-3">
                  <p className="fw-bolder">عدم نمایش در لیست محصولات</p>
                  <p className="text-muted fw-bold">
                    آیا برای عدم نمایش در لیست محصولات خود اطمینان دارید؟
                  </p>
                </div>
              ) : (
                <div className="col-12 px-1 mb-3">
                  <p className="fw-bolder">نمایش در لیست محصولات</p>
                  <p className="text-muted fw-bold">
                    آیا برای نمایش در لیست محصولات خود اطمینان دارید؟
                  </p>
                </div>
              )}

              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 text-danger fw-bold"
                  onClick={() =>
                    this.state.type === "delete"
                      ? this.delete_product()
                      : this.state.type === "show"
                      ? this.show_product(true)
                      : this.show_product(false)
                  }
                >
                  {this.state.type === "delete"
                    ? "حذف"
                    : this.state.type === "show"
                    ? "نمایش"
                    : "عدم نمایش"}
                </button>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 rounded28 border text-muted fw-bold"
                  onClick={() => this.setState({ acceptModal: false })}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default ManagementProducts;
